// extracted by mini-css-extract-plugin
export default {"container":"container__kOvrb","dot":"dot__E-XXA"};